import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'
import { usePermission } from '@tomfxs/permissions-client'

const FeedbackQuestionPoolCreateForm = React.lazy(() => loadComponent('mfeedback', 'QuestionPoolCreateForm'))

export function QuestionPoolCreateRoute() {
    const navigate = useNavigate()
    const canCreate = usePermission('feedback.questionPool.create', {})

    const onCreate = useCallback(() => {
        navigate('/marah-feedback/question_pools')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/marah-feedback/question_pools')
    }, [navigate])

    return (
        <RouteContainer>
            <FeedbackQuestionPoolCreateForm canCreate={canCreate} onCreate={onCreate} onCancel={onClose} />
        </RouteContainer>
    )
}
